<template>
  <b-card header-tag="header" class="apply-box">
    <h4>The submission of this form will trigger a job that will attempt to perform the following updates:</h4>
    <ol>
      <li>It finds all applications of the candidate’s email address in your Greenhouse instance.</li>
      <li>Imports the application status from Greenhouse where we already have an application in Real Links.</li>
      <li>Imports any application from Greenhouse where the application source is Real Links but we do not have the application already.</li>
      <li>Attempts to push source and referrer information for all applications we have to Greenhouse.</li>
    </ol>
    <p>The job will run asynchronously and may take a few minutes to complete.</p>
    <hr />
    <advanced-form
      autocomplete="off"
      submit-label="Import Applications"
      :form="formFields"
      v-bind="form"
      v-model="form"
      @submit="input()"
    />
    <b-row>
      <b-col cols="12" v-if="triggered">
        <h3 class="text-center pt-3">Import started. Please wait…</h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import AdvancedForm from '@/components/AdvancedForm';
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';

const ImportJobApplicationsMutation = gql`
  mutation ImportJobApplication($input: String!) {
    importJobApplication(input: $input)
  }
`;

export default {
  name: 'Apply-Import-Recruiter',
  components: {
    AdvancedForm
  },
  data: () => ({
    triggered: false,
    form: {},
    err: null,
    state: null,
  }),
  props: {
    applicationsArray: Array,
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
    formFields() {
      return {
        emailAddress: {
          label: 'Email Address',
          placeholder: 'e.g. john.smith@gmail.com',
          required: true,
          type: 'STRING',
          options: {
            autocomplete: 'off',
          },
          validation: {
            isEmailAddress: true,
          },
        }
      };
    },
  },
  methods: {
    async input() {
      this.triggered = true;

      const input = {
        candidateEmail: this.form.emailAddress,
        integrationType: 'greenhouse',
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: ImportJobApplicationsMutation,
          variables: { input: JSON.stringify(input) },
        });

        const { data: { importJobApplication } } = response;
        const { status, message } = importJobApplication ? JSON.parse(importJobApplication) : {};

        if (status === 'success') {
          this.$notification({ title: 'Import Routine Completed', message, variant: 'success' });
        } else {
          this.$notification({ title: 'An Error Occurred', message, variant: 'danger' });
        }
      } catch (error) {
        console.log(error);
        this.$notification({ title: 'An Error Occurred', message: error.message, variant: 'danger' });
      }
    },
  }
};
</script>

<style lang="scss">
  @import './../../scss/variables';

  .apply-box {
    form {
      padding: 1rem;
      width: 100%;
    }

    .btn {
      margin: 0 auto;
    }

    .btn-primary {
      margin-top: 1em;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/applyImport.vue